<template>
    <!-- 详情模块 -->
    <div class="form-wrapper">
        <div class="page-top-handle">
            <Button v-if="sendSmsStatus != 2" type="primary" :loading="loadingM" @click="sendMi" style="margin-right: 16px">
                <span v-if="!loadingM">发送秘钥</span>
                <span v-else>发送中...</span>
            </Button>
            <Button v-if="sendSmsStatus != 1" type="default"  @click="handleDeal">驳 回</Button>
            <Button style="margin-left: 8px;" type="default" v-if="applicantStatus === '0' || applicantStatus === '1'" @click="handleEdit()">编辑</Button>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>审核日志</span>
            </div>
            <Table border size="large"
                   :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue link-span" @click="handleJump(row.projectId)">{{row.projectName}}</span>
                </template>
            </Table>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>项目信息登记</span>
            </div>
            <ul class="ft-form-wrapper">
                <li class="ft-form-item">
                    <div class="ft-th">项目名称</div>
                    <div class="ft-td ft-bold">{{formData.name}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">施工许可证号</div>
                    <div class="ft-td">{{formData.buildPermitCode}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目所在地区</div>
                    <div class="ft-td">
                        <span>{{formData.areaName}}</span>
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目类别</div>
                    <div class="ft-td">
                        <span>{{common.transfer(formData.projectType, common.projectTypes)}}</span>
                    </div>
                </li>
                <li class="ft-form-item" style="width: 100%">
                    <div class="ft-th">项目状态</div>
                    <div class="ft-td">
                        <span>{{common.transfer(formData.prjStatus, common.prjStatusS)}}</span>
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目开工日期（计划开工日期）</div>
                    <div class="ft-td">
                        {{formData.startDate}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目竣工日期（计划竣工日期）</div>
                    <div class="ft-td">
                        {{formData.completeDate}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">总投资（万元）</div>
                    <div class="ft-td">
                        {{formData.invest}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">总面积（平方米）</div>
                    <div class="ft-td">
                        {{formData.buildingArea}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">施工总承包单位名称</div>
                    <div class="ft-td">
                        {{formData.contractorCorpName}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">施工总承包单位统一社会信用代码</div>
                    <div class="ft-td">{{formData.contractorCorpCode}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目经理</div>
                    <div class="ft-td">{{formData.pmName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.pmPhone}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">建设单位名称</div>
                    <div class="ft-td">{{formData.buildCorpName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">建设单位统一社会信用代码</div>
                    <div class="ft-td">{{formData.buildCorpCode}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">建设单位项目负责人</div>
                    <div class="ft-td">{{formData.supervisingEngineerName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.supervisingEngineerPhone}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">监理单位名称</div>
                    <div class="ft-td">{{formData.adminName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">监理单位统一社会信用代码</div>
                    <div class="ft-td">{{formData.adminId}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目总监</div>
                    <div class="ft-td">{{formData.projectDirector}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.projectDirectorPhone}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">设备安装公司名称</div>
                    <div class="ft-td">{{formData.equipmentCompanyName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">设备安装公司电话</div>
                    <div class="ft-td">{{formData.equipmentCompanyMobile}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目实名制负责人姓名</div>
                    <div class="ft-td">{{formData.applicantName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目实名制负责人联系电话</div>
                    <div class="ft-td">{{formData.applicantMobile}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目实名制负责人邮箱</div>
                    <div class="ft-td">{{formData.email}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">备注</div>
                    <div class="ft-td">{{formData.remark}}</div>
                </li>
            </ul>
        </div>
        <Modal v-model="lModal"  :mask-closable='false' width="650">
            <p slot="header">
                <span>请填写驳回原因</span>
            </p>
            <div>
                <Form ref="formLine" class="form-list" :model="formLine" :rules="ruleLine" inline :label-width="100" label-position="right">
                    <Row :gutter="24">
                        <Col span="24">
                            <FormItem label="驳回原因" prop="rejectReason">
                                <Input type="textarea" :autosize="{minRows:3,maxRows: 5}"  v-model="formLine.rejectReason" ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer" style="text-align: center">
                <Button type="primary" :loading="loadingL" @click="handleSubmit('formLine')">驳 回</Button>
                <Button @click="lModal=false" style="margin-left: 16px">取 消</Button>
            </div>
        </Modal>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    export default {
        components: {

        },
        data(){
            return {
                applicantStatus: '',
                sendSmsStatus: '',
                loadingM: false,
                tProjectTokenId:'',
                // 驳回 <
                lModal: false,
                loadingL: false,
                formLine: {
                    rejectReason: ''
                },
                ruleLine: {
                    rejectReason: [
                        { required: true, message: '驳回原因不能为空', trigger: 'blur' }
                    ],
                },
                // >
                formData:{
                },
                tableColumns:[
                    {
                        title: '审核时间',
                        key: 'auditTime',
                        align:'center',
                    },
                    {
                        title: '审核人',
                        key: 'auditPerson',
                        align:'center'
                    },
                    {
                        title: '审核结果',
                        key: 'auditResult',
                        align:'center'
                    },
                    {
                        title: '详情',
                        key: 'auditDetail',
                        align:'center',
                        minWidth: 200
                    }
                ],
                tableData:[],

            };
        },
        computed:{
            ...mapState(['dict']),
        },
        created(){
            this.tProjectTokenId= this.$route.query.tProjectTokenId;
            this.sendSmsStatus= this.$route.query.sendSmsStatus;
            this.applicantStatus = this.$route.query.applicantStatus;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            // 编辑
            handleEdit() {
                this.$router.push({
                    name: 'secretKeyForm',
                    query: {
                        tProjectTokenId: this.tProjectTokenId,
                        sendSmsStatus: this.sendSmsStatus,
                    }
                });
            },
            // 驳回
            handleDeal(){
                this.lModal = true;
                this.$refs.formLine.resetFields();
            },
            // 驳回确认
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    this.loadingL = true;
                    this.axios({
                        method: 'GET',
                        url: '/project/sendRejectSms',
                        params: {
                            userName: localStorage.getItem('userName'),
                            tProjectTokenId: this.tProjectTokenId,
                            rejectReason: this.formLine.rejectReason,
                        },
                    }).then((response) => {
                        this.loadingL = false;
                        if(response.data.success){
                            this.lModal = false;
                            this.$Message.success('提交成功!');
                            this.$router.go(-1);
                        }else {
                            this.$Message.warning(response.data.errorMsg);
                        }
                    }).catch( ()=> {
                        this.loadingL = false;
                    });
                })
            },
            // 发送秘钥
            sendMi(){
                this.loadingM = true;
                this.axios({
                    method: 'get',
                    url:'/project/sendSmsSecretKey',
                    params: {
                        userName: localStorage.getItem('userName'),
                        tProjectTokenId: this.tProjectTokenId,
                    }
                }).then((res) => {
                    this.loadingM = false;
                    if(res.data.success) {
                        this.$Message.success('发送成功!');
                        this.$router.go(-1);
                    }else {
                        this.$Modal.warning({
                            title: '提示',
                            content: res.data.errorMsg,
                            onOk:()=>{ }
                        });
                    }
                }).catch(()=>{
                    this.loadingM = false;
                })
            },
            transfer(oldValue,arr) {
                let newValue = '';
                if(arr){
                    for (let i=0;i<arr.length;i++){
                        if (arr[i].code === oldValue) {
                            newValue = arr[i].name;
                            break;
                        }
                    }
                }
                return newValue;
            },
            /*获取页面信息*/
            getPageData(){
                this.axios({
                    method: 'get',
                    url:'/project/getProjectTokenDetail',
                    params:{
                        tProjectTokenId: this.tProjectTokenId,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.tableData=response.data.data.loggingList || [];
                        this.formData=response.data.data;
                    }
                });
            },
        }
    };
</script>
